import { Map } from 'immutable';

import { OPEN_SIDEBAR_NAV, DISMISS_SIDEBAR_NAV } from './actionTypes';

// Create default store state
const defaultState = Map({
  isSidebarNavShowing: false,
});

// Define action reducers
const ui = (state = defaultState, action) => {
  switch (action.type) {
    case OPEN_SIDEBAR_NAV:
      return state.set('isSidebarNavShowing', true);
    case DISMISS_SIDEBAR_NAV:
      return state.set('isSidebarNavShowing', false);
    default:
      return state;
  }
};

export default ui;
